export const supportUrl = "https://verbit.happyfox.com/new/"